// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4063":"9457f313","4715":"d863a3a5","5262":"f1de49d1","9310":"f1de49d1"}[chunkId] + ".chunk.css";
};